export default __webpack_public_path__ + "static/assets/med_gel_solid_04_b.f5f2a3d0.png";